export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Caret left</title>
    <path
      d="M20 5 9 16l11 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
